<template>
  <main class="main main--has-floating-buttons">
    <portal to="headerTitle">
      {{ $t('admin.pageDiscountCodes.title') }}
    </portal>

    <template v-if="discountCodes !== null">
      <card :title="$t('admin.pageDiscountCodes.card.discountCodes')" cols="12">
        <hm-card-inner :full-size="true">
          <hm-col cols="12">
            <template v-for="discountCode in discountCodes" v-if="!discountCode.deleted">
              <hm-card-inner-line :title="getName(discountCode)" :clickable="true" :key="discountCode.id" @click="routeToDiscountCode(discountCode)" />
            </template>
          </hm-col>
        </hm-card-inner>
      </card>

      <card v-if="!isEmpty(deletedDiscountCodes)" :title="$t('admin.pageDiscountCodes.card.deletedDiscountCodes')" cols="12" card-type="collapsible">
        <hm-card-inner :full-size="true">
          <hm-card-inner v-for="discountCode in deletedDiscountCodes"
                         :title="getName(discountCode)"
                         :clickable="true"
                         :key="discountCode.id"
                         @click="routeToDiscountCode(discountCode)" />
        </hm-card-inner>
      </card>
    </template>

    <hm-floating-buttons id="actions" ref="floatingButtons">
      <hm-floating-button :label="$t('admin.pageDiscountCodes.actions.more')" icon="plus" color="blue">
        <hm-floating-child-button :label="$t('admin.pageDiscountCodes.actions.addDiscountCode')" icon="plus" color="blue" @click="addDiscountCode()" />
      </hm-floating-button>
    </hm-floating-buttons>
  </main>
</template>

<script>
/* eslint func-names: 0 */

import HotelmeisterMixin from '@/mixins/HotelmeisterMixin';
import vue2Dropzone from 'vue2-dropzone';
import draggable from 'vuedraggable';
import { cloneDeep, flattenDeep, groupBy, isEmpty, isNil, keyBy, sortBy } from 'lodash';
import SaveWatchMixin from '@/mixins/SaveWatchMixin';

export default {
  name: 'PageDiscountCodes',

  mixins: [HotelmeisterMixin, SaveWatchMixin],

  data() {
    return {
      discountCodes: null,
    };
  },

  computed: {
    deletedDiscountCodes: function () {
      return isNil(this.discountCodes) ? null : this.discountCodes.filter(it => it.deleted === true);
    },
    enums: function () {
      return this.$store.getters['enums/enums'];
    },
  },

  watch: {
  },

  created: function () {
    this.loadData();
  },

  updated() {
  },

  beforeDestroy() {
  },

  methods: {
    loadData() {
      this.axios.get(this.serviceUrls.discountCode.list(this))
        .then((response) => {
          this.discountCodes = sortBy(response.data.data, ['name']);

          this.$serviceBus.$emit('discountCode.list', this.discountCodes);
        });
    },
    addDiscountCode() {
      this.axios.post(this.serviceUrls.discountCode.list(this), {
        name: 'New',
      })
        .then((response) => {
          this.loadData();
          this.$serviceBus.$emit('hotelSettings.update');
        })
        .catch((error) => {
          if (isNil(error.response)) this.showErrorMessage();
          this.showMessages(error.response);
        });
    },
    getName(discountCode) {
      const name = isNil(discountCode) ? null : discountCode.code;
      if (isNil(name)) return '-';
      let ret = name;

      let details = '';

      if (discountCode.percentage !== 0) details += `${discountCode.percentage.toFixed(2)} %`;
      if (!isNil(discountCode.amount) && discountCode.amount !== 0) details += `${isEmpty(details) ? '' : ' + '}${discountCode.amount.toFixed(2)} ${this.hotelSettings.details.currency}`;


      if (!isNil(ret)) {
        ret = ret.trim();
      }

      if (isEmpty(ret)) {
        ret = '-';
      }

      ret = `${ret}<span class="color--gray"> // ${details}</span>`;

      return ret || '-';
    },
    routeToDiscountCode(discountCode) {
      this.$router.push({
        name: 'discountCode',
        params: {
          discountCodeId: discountCode.id,
        },
      });
    },
  },
};
</script>

<!-- Scoped SCSS  -->
<style lang="scss" scoped>
</style>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/pages/admin/PageDiscountCodes.vue